module.exports = __webpack_public_path__ + "media/images/vip-255a5e96f476af279d4ad0ba91e916e4.png";